import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { StudentNameAndID } from '../../../server/types';
import { Course } from '@/core/interfaces';

export function studentExistsValidator(
  students: StudentNameAndID[],
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const index = students
      .map((student) => `${student.name} (${student.uwf_id})`)
      .findIndex((x) => x === control.value);

    if (!control.value) {
      return { required: { value: control.value } };
    }

    return index === -1 ? { not_found: { value: control.value } } : null;
  };
}

export function courseExistsValidator(courses: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const index = courses.findIndex((x) => x === control.value);

    if (!control.value) {
      return { required: { value: control.value } };
    }

    return index === -1 ? { not_found: { value: control.value } } : null;
  };
}
